// Libraries
var React = require('react');

// Components
var GenericImage = require('../GenericImage/GenericImage');
var OneHotspurButton = require('../OneHotspurButton/OneHotspurButton');

// Style
require('./Features.scss');

class Features extends React.Component {
  render() {
    const additionalSectionClass = this.props.data.isOneHotspur ? ' c-section--one-hotspur' : this.props.data.isPremium ? ' c-section--premium' : '';
    const additionalFeaturesClass = this.props.data.isOneHotspur ? ' c-features--one-hotspur' : this.props.data.isPremium ? ' c-features--premium' : '';
    return (
      <div className={`c-section c-section--gutter c-section--tight-mobile${additionalSectionClass}`} id={this.props.data.id}>
        <div className="c-section__inner">
          
          <div className={`c-features${additionalFeaturesClass}`}>
            <div className="c-features__inner">

              {this.props.data.title !== '' &&
                <h2 className="c-features__title"><span class="c-features__title__inner">{this.props.data.title}</span></h2>
              }

              {this.props.data.items.length &&
                <div className="c-features__list">
                  <div className="c-grid c-grid--center c-grid--features">
                    <div className="c-grid__inner">
                      
                      {this.props.data.items.map((item) => {
                        return (
                          <div key={item} className="c-grid__col c-grid__col--6-mobile c-grid__col--4-tablet">
                            <div class="c-grid__col__inner">
                              {item.link.url && item.link.caption ?
                                <a href={item.link.url} className={`c-features__item ${this.props.data.fadeReductionClass}`} aria-label={item.title}>
                                  <div className="c-features__item__content">
                                    <div className="c-features__item__content__inner">
                                      {item.title !== '' &&
                                        <h3 className="c-features__item__title">{item.title}</h3>
                                      }
                                      {item.subTitle !== '' &&
                                        <p className="c-features__item__subtitle">{item.subTitle}</p>
                                      }
                                      <p className="c-features__item__action">
                                        {this.props.data.isOneHotspur &&
                                          <OneHotspurButton tag="span" size="small" alt="false" text={item.link.caption} />
                                        }
                                        {!this.props.data.isOneHotspur &&
                                          <span className={`c-button c-button--on-dark c-button--small${this.props.data.isPremium ? " c-button--premium" : ""}`}>{item.link.caption}</span>
                                        }
                                      </p>
                                    </div>
                                  </div>
                                  <GenericImage loading="lazy" image={item.image} class="c-features__item__image" />
                                </a>
                                :
                                <div class="c-features__item">
                                  <div className="c-features__item__content">
                                    <div className="c-features__item__content__inner">
                                      {item.title !== '' &&
                                        <h3 className="c-features__item__title">{item.title}</h3>
                                      }
                                      {item.subTitle !== '' &&
                                        <p className="c-features__item__subtitle">{item.subTitle}</p>
                                      }
                                    </div>
                                  </div>
                                  <GenericImage loading="lazy" image={item.image} class="c-features__item__image" />
                                </div>
                              }
                            </div>
                          </div>
                        )
                      })}

                    </div>
                  </div>
                </div>
              }

            </div>
          </div>

        </div>
      </div>
    );
  }
};

module.exports = Features;


// WEBPACK FOOTER //
// ./src/components/Features/Features.js